import { styled } from '@mui/material'

export const Container = styled('div')({
  padding: 90,
  display: 'flex',
  justifyContent: 'center',
})

export const Content = styled('div')({
  maxWidth: 800,
})
